exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".form-calc{background:#efefef;border:2px solid #efefef;margin:10px;padding:10px;min-height:432px}.form-morning{color:#ff8c00}.form-evening{color:#00008b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-89781196","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/azcalc.vue
// module id = 712
// module chunks = 0